import { render, staticRenderFns } from "./PortfolioFooter.vue?vue&type=template&id=71423a37&scoped=true&"
import script from "./PortfolioFooter.vue?vue&type=script&lang=js&"
export * from "./PortfolioFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71423a37",
  null
  
)

export default component.exports